module.exports = __webpack_public_path__ + "static/media/logo-hdi.384ebeb6.png";